
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lmzngywecekyjriavqri.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imxtem5neXdlY2VreWpyaWF2cXJpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI0ODQzMjYsImV4cCI6MjA1ODA2MDMyNn0.3KmyHfH5iLwd4kzQ_NzEYRhBcdiN0b2ec_JAtQLBVqs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
